/* Wishlist hearts (PDP + product cards + drawer).
 * Logged-in only: state lives in the customer metafield custom.wishlist and is
 * toggled through the App Proxy (/apps/avatar/wishlist/toggle). Guests are shown
 * the account drawer. Initial state is hydrated from window.alasilWishlist. */
(function () {
  'use strict';
  if (window.__alasilWishlistInitialized) return;
  window.__alasilWishlistInitialized = true;
  var PROXY = '/apps/avatar/wishlist';
  var SYNC_PREFIX = 'alasil:wishlist-sync:';
  function initialIds() {
    /* Read the non-executable JSON node directly. On Shopify preview domains,
       an inline bootstrap global can be unavailable when the deferred asset
       runs even though the server-rendered state is already in the DOM. */
    var state = document.getElementById('AlasilWishlistState');
    if (state) {
      try {
        var parsed = JSON.parse(state.textContent || '[]');
        if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
      } catch (_) {}
    }
    return Array.isArray(window.alasilWishlist) ? window.alasilWishlist.map(String).filter(Boolean) : [];
  }
  var ids = new Set(initialIds());
  window.alasilWishlist = Array.from(ids);
  var channel = null;
  var wishlistObserver = null;
  var suspended = false;

  function scope() {
    return (document.body && document.body.getAttribute('data-customer-scope')) || 'guest';
  }

  function normalize(nextIds) {
    return Array.isArray(nextIds) ? nextIds.map(String).filter(Boolean) : [];
  }

  function markBtn(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      on
        ? (btn.getAttribute('data-wishlist-remove-label') || window.alasilWishlistRemoveLabel || 'Remove from wishlist')
        : (btn.getAttribute('data-wishlist-add-label') || window.alasilWishlistAddLabel || 'Save to wishlist')
    );
  }
  function markAll(id, on) {
    var list = document.querySelectorAll('[data-wishlist-id="' + id + '"]');
    for (var i = 0; i < list.length; i++) markBtn(list[i], on);
  }
  var toastEl, toastTimer;
  function setBusyAll(id, busy) {
    var list = document.querySelectorAll('[data-wishlist-id="' + id + '"]');
    for (var i = 0; i < list.length; i++) {
      list[i].classList.toggle('is-busy', busy);
      list[i].disabled = !!busy;
      list[i].setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function showToast(msg, isError) {
    /* Pin inside the account drawer panel (above the lottie); fall back to body. */
    var host = document.querySelector('#AccountDrawer .account-drawer__panel') || document.body;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wishlist-toast';
    }
    toastEl.setAttribute('role', isError ? 'alert' : 'status');
    toastEl.classList.toggle('is-error', !!isError);
    if (toastEl.parentNode !== host) host.appendChild(toastEl);
    toastEl.textContent = msg;
    void toastEl.offsetWidth; /* reflow so the transition runs */
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  function hydrate() {
    var list = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < list.length; i++) {
      markBtn(list[i], ids.has(String(list[i].getAttribute('data-wishlist-id'))));
    }
  }

  /* Product rails and the account drawer are lazy-rendered after the initial
     DOMContentLoaded hydration. Observe only added subtrees that contain a
     wishlist control so those late controls never paint with stale state. */
  var hydrateQueued = false;
  function queueHydrate() {
    if (hydrateQueued) return;
    hydrateQueued = true;
    requestAnimationFrame(function () {
      hydrateQueued = false;
      if (!suspended) hydrate();
    });
  }
  function observeLateWishlistControls() {
    if (suspended || wishlistObserver || !document.body || !('MutationObserver' in window)) return;
    wishlistObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-wishlist-toggle]')) ||
              (node.querySelector && node.querySelector('[data-wishlist-toggle]'))) {
            queueHydrate();
            return;
          }
        }
      }
    });
    wishlistObserver.observe(document.body, { childList: true, subtree: true });
  }

  function applyState(nextIds) {
    ids = new Set(normalize(nextIds));
    window.alasilWishlist = Array.from(ids);
    hydrate();
  }

  function emitState(source) {
    try {
      document.dispatchEvent(new CustomEvent('alasil:wishlist-state-changed', {
        detail: { ids: Array.from(ids), source: source || 'storefront' }
      }));
    } catch (_) {}
  }

  function broadcastState() {
    var message = { scope: scope(), ids: Array.from(ids), at: Date.now() };
    if (channel) {
      try { channel.postMessage(message); } catch (_) {}
    }
    try {
      var key = SYNC_PREFIX + message.scope;
      localStorage.setItem(key, JSON.stringify(message));
      localStorage.removeItem(key);
    } catch (_) {}
  }

  function setState(nextIds, options) {
    applyState(nextIds);
    if (options && options.broadcast) broadcastState();
    emitState(options && options.source);
  }

  function receiveState(message) {
    if (!message || message.scope !== scope() || !Array.isArray(message.ids)) return;
    applyState(message.ids);
    emitState('another-tab');
  }

  function resumeWishlist() {
    suspended = false;
    if (!channel && 'BroadcastChannel' in window) {
      try {
        channel = new BroadcastChannel('alasil:wishlist');
        channel.onmessage = function (event) { receiveState(event.data); };
      } catch (_) { channel = null; }
    }
    observeLateWishlistControls();
    hydrate();
  }
  window.addEventListener('pagehide', function () {
    suspended = true;
    if (channel) { channel.close(); channel = null; }
    if (wishlistObserver) { wishlistObserver.disconnect(); wishlistObserver = null; }
    clearTimeout(toastTimer);
    if (toastEl) toastEl.classList.remove('is-visible');
  });
  window.addEventListener('pageshow', resumeWishlist);
  window.addEventListener('storage', function (event) {
    if (!event.key || event.key !== SYNC_PREFIX + scope() || !event.newValue) return;
    try { receiveState(JSON.parse(event.newValue)); } catch (_) {}
  });

  function analyticsItem(button, productId) {
    var item = { product_id: productId };
    var name = button.getAttribute('data-wishlist-product-name');
    if (name) item.item_name = name;
    // Read the live control at click time. Never infer the variant from a
    // default product variant: the shopper may already have changed it.
    var scope = button.closest('.product-card-wrapper[data-product-id], [data-analytics-product-id][id^="MainProduct-"]');
    var scopeProductId = scope && (scope.dataset.productId || scope.dataset.analyticsProductId);
    var input = scope && String(scopeProductId) === productId && scope.querySelector('form[action*="/cart/add"] [name="id"], .product-variant-id');
    var variantId = input && String(input.value || '');
    if (!variantId && scope && String(scopeProductId) === productId && scope.id && scope.id.indexOf('MainProduct-') === 0 && typeof window.AlAsilProductAnalyticsItem === 'function') {
      var selected = window.AlAsilProductAnalyticsItem(productId);
      if (selected) {
        item = Object.assign({}, selected, item);
        variantId = selected.variant_id;
      }
    }
    if (variantId && /^\d+$/.test(variantId)) {
      item.variant_id = variantId;
      var country = window.Shopify && window.Shopify.country;
      if (/^[A-Z]{2}$/.test(country || '')) item.item_id = 'shopify_' + country + '_' + productId + '_' + variantId;
    }
    return item;
  }

  function onClick(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    /* Capture phase + stop so a heart inside a card link never navigates. */
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;

    if (!window.alasilLoggedIn) {
      /* Force login: open the account drawer in its guest (sign-in) state, then
         show the "must be logged in" toast AFTER it slides in (more noticeable
         than firing both at once). */
      if (typeof window.openAccountDrawer === 'function') {
        window.openAccountDrawer(btn);
        setTimeout(function () { showToast(window.alasilWishlistLoginMsg || 'You must be logged in'); }, 480);
      } else {
        /* Account drawer is lazy-loaded. Reuse its normal trigger so the shared
           loader can fetch the script and replay the click without navigating. */
        var accountTrigger = document.querySelector(
          '[data-account-drawer-trigger], [data-action="account"], .header__icon--account'
        );
        if (accountTrigger) accountTrigger.click();
        setTimeout(function () { showToast(window.alasilWishlistLoginMsg || 'You must be logged in'); }, 480);
      }
      return;
    }
    var id = String(btn.getAttribute('data-wishlist-id'));
    var was = ids.has(id);
    var trackedItem = !was ? analyticsItem(btn, id) : null;
    /* Optimistic toggle. */
    if (was) ids.delete(id); else ids.add(id);
    markAll(id, !was);
    setBusyAll(id, true);

    fetch(PROXY + '/toggle', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: id, inWishlist: !was }),
    })
      .then(function (r) { if (!r.ok) throw new Error('toggle'); return r.json(); })
      .then(function (d) {
        var on = !!d.inWishlist;
        if (Array.isArray(d.ids)) applyState(d.ids);
        else {
          if (on) ids.add(id); else ids.delete(id);
          markAll(id, on);
          window.alasilWishlist = Array.from(ids);
        }
        if (!was && on && typeof window.publishAlasilEvent === 'function') {
          window.publishAlasilEvent('alasil:storefront_interaction', { event_name: 'add_to_wishlist', product_id: id, items: [trackedItem] });
        }
        broadcastState();
        emitState('mutation');
        /* Removed from inside the drawer wishlist list → drop the card. */
        if (!on) { var card = btn.closest('.ad__wish-card'); if (card) card.remove(); }
      })
      .catch(function () {
        /* Revert on failure. */
        if (was) ids.add(id); else ids.delete(id);
        markAll(id, was);
        window.alasilWishlist = Array.from(ids);
        showToast(window.alasilWishlistErrorMsg || 'Could not update your wishlist. Please try again.', true);
      })
      .then(function () { setBusyAll(id, false); });
  }

  document.addEventListener('click', onClick, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resumeWishlist, { once: true });
  } else {
    resumeWishlist();
  }
  document.addEventListener('shopify:section:load', hydrate);
  /* Let the drawer re-mark hearts after it swaps in a fresh wishlist list. */
  window.alasilWishlistHydrate = hydrate;
  window.alasilWishlistSetState = setState;
})();
